// src/modules/app-views/crm/pages/Boards/tabs/MuralTab/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import StickyBoard from 'layouts/BottomDrawer/tabs/MuralTab/StickyBoard';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const MuralTab = props => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { onReady } = props;

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return <StickyBoard onReady={onReady} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default MuralTab;
